import React, { useState } from 'react';
import LearnModal from './LearnModal';

const LearnArticle = (article) => {

    const [modalStatus, setModalStatus] = useState(false);

    return (
        <div className="learn-article">
            <a onClick={() => setModalStatus(true)}>
                <img src={article.image} alt={article.heading} />
                <h4>{article.heading}</h4>
                <p>Learn More &gt;</p>
            </a>

            {(modalStatus) ? <LearnModal
                onLearnModalClose={() => setModalStatus(false)}
                article={article}
            /> : null
            }
        </div>
    );
}

export default LearnArticle;